import { getConfig } from '@edx/frontend-platform';
import { getHttpClient } from '@edx/frontend-platform/auth';

// Two ways to reach the OTP-entry endpoints: by `token` (the real emailed link,
// works standalone with no app state), or by `email` (the in-app "Enter Code"
// button, which already knows the email the user just typed - see PT finding 5.8,
// recommendation #1: the forgot-password response no longer carries a token).

export async function validateOtp(code, { token, email } = {}) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/json' },
  };

  const url = token
    ? new URL(`${getConfig().LMS_BASE_URL}/verify_forgot_password_code/${token}/`)
    : new URL(`${getConfig().LMS_BASE_URL}/verify_forgot_password_code/verify/`);
  const body = token ? { code } : { code, email };

  const { data } = await getHttpClient()
    .post(url.href, JSON.stringify(body), requestConfig)
    .catch((e) => {
      throw (e);
    });
  return data;
}

export async function fetchOtpTimer({ token, email } = {}) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/json' },
  };

  if (token) {
    const url = new URL(`${getConfig().LMS_BASE_URL}/verify_forgot_password_code/${token}/`);
    const { data } = await getHttpClient()
      .get(url.href, requestConfig)
      .catch((e) => {
        throw (e);
      });
    return data;
  }

  const url = new URL(`${getConfig().LMS_BASE_URL}/verify_forgot_password_code/status/`);
  const { data } = await getHttpClient()
    .post(url.href, JSON.stringify({ email }), requestConfig)
    .catch((e) => {
      throw (e);
    });
  return data;
}
